import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getReq, postReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/partner-funds");
export var getAllPartnerFunds = function getAllPartnerFunds(params) {
  return getReq(BASE_URL, {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    }), (params === null || params === void 0 ? void 0 : params.user) && {
      user_id: params === null || params === void 0 ? void 0 : params.user
    })
  });
};
export var getPartnerFundsBalance = function getPartnerFundsBalance(params) {
  return getReq("".concat(BASE_URL, "/get-balance"), {
    params: _objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.partner_id) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner_id
    }), (params === null || params === void 0 ? void 0 : params.user_id) && {
      user_id: params === null || params === void 0 ? void 0 : params.user_id
    })
  });
};
export var postCommissionReport = function postCommissionReport(params) {
  return postReq("".concat(BASE_URL, "/commission-report"), {
    partner_id: params === null || params === void 0 ? void 0 : params.partner,
    user_id: params === null || params === void 0 ? void 0 : params.user,
    amount: params === null || params === void 0 ? void 0 : params.amount
  });
};